import React from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-tabs/style/react-tabs.css'
import SwipeableEdgeDrawer from '../SwipeableEdgeDrawer/SwipeableEdgeDrawer'
import Toolbar from './Toolbar'
import Heading from '../Heading/Heading'
import { isMobile } from '../../helpers/isMobile'
import * as Styled from './styles'
import { setIsMobileDrawerOpen } from '../../store/ui/uiSlice'
import { useAppDispatch, useAppSelector } from '../../hooks'

const ToolbarContainer: React.FC = () => {
  const { content } = useAppSelector((state) => state.init)
  const { isMobileDrawerOpen, isSummaryPreviewExpanded } = useAppSelector((state) => state.ui)
  const dispatch = useAppDispatch()

  if (isMobile()) {
    if (isSummaryPreviewExpanded) return
    return (
      <SwipeableEdgeDrawer
        open={isMobileDrawerOpen}
        onOpen={() => dispatch(setIsMobileDrawerOpen(true))}
        onClose={() => dispatch(setIsMobileDrawerOpen(false))}
      >
        <Toolbar />
      </SwipeableEdgeDrawer>
    )
  } else {
    return (
      <Styled.ToolbarContainer>
        <Heading level={1} className="toolbar-heading">
          {content.other.toolbarHeading}
        </Heading>
        <Toolbar />
      </Styled.ToolbarContainer>
    )
  }
}

export default ToolbarContainer
